import { render } from "./ChatSidebar.vue?vue&type=template&id=2248891a&scoped=true"
import script from "./ChatSidebar.vue?vue&type=script&lang=js"
export * from "./ChatSidebar.vue?vue&type=script&lang=js"

import "./ChatSidebar.vue?vue&type=style&index=0&id=2248891a&scoped=true&lang=css"
import "./ChatSidebar.vue?vue&type=style&index=1&id=2248891a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2248891a"]])

export default __exports__